/**
 * Default background color of highlighted texts
 * @type {string}
 */
const bgColorDefault = '#F2C216';

/**
 * Create a RegEx pattern to find the desired words
 * @param {(string|string[])} word - A string or an array of strings to use to create the RegEx pattern
 * @param {boolean} [liveHighlighting=false] - Specify if the pattern should be a live search. Default is false
 * @returns {string} The RegEx pattern to find looked for words
 */
function selectPattern(word, liveHighlighting = true) {
  let result = '';
  const explodedWord = Array.isArray(word) ? word.join('|') : word;
  if (!liveHighlighting) {
    result = `\\b(${ explodedWord })\\b`;
  } else {
    result = `(${ explodedWord })`;
  }
  return result;
}

/**
 * Create tags with highlighted looked for text
 * @param {string} content - Content where find text to wordHighlight
 * @param {(string|string[])} word - A word or an array of words to looking for
 * @param {string} patternSelected - RegEx pattern to find looked for words
 * @param {string} bgColor - Background color of highlighted container
 * @returns {string} Return replaced content with highlighted tags
 */
function highlight(content, word, patternSelected, bgColor) {
  const spanStart = `<span style='background-color:${ bgColor };'>`;
  const spanEnd = '</span>';
  let result = content;
  if (word !== '') {
    const regex = new RegExp(patternSelected, 'gi');
    result = content.replace(regex, `${spanStart }$&${ spanEnd}`);
  }
  return `<span>${result}</span>`;
}

const vueHighlighter = {
  bind(el, binding) {
    const elements = el.querySelectorAll('[data-highlight]');
    elements.forEach((item) => {
      const originalContent = item.innerHTML;
      let pattern = '';
      let word = '';
      let bgColor = bgColorDefault;
      if (binding.value.word !== undefined) {
        word = binding.value.word;
      }
      if (binding.value.live !== undefined) {
        pattern = selectPattern(word, binding.value.live);
      }
      if (binding.value.style !== undefined) {
        bgColor = bgColorDefault;
      }
      // eslint-disable-next-line no-param-reassign
      item.innerHTML = highlight(originalContent, word, pattern, bgColor);
    });
  },
  update(el, binding) {
    const elements = el.querySelectorAll('[data-highlight]');
    elements.forEach((item) => {
      let pattern = '';
      let bgColor = bgColorDefault;
      if (binding.value.style !== undefined) {
        bgColor = bgColorDefault;
      }
      if (binding.value.live) {
        pattern = selectPattern(binding.value.word, binding.value.live);
        // eslint-disable-next-line no-param-reassign
        item.innerHTML = highlight(item.textContent, binding.value.word, pattern, bgColor);
      }
    });
  },
};

export default vueHighlighter;
